
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Image, Link } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Wie kommen wir durch den Winter, wenn sich das Leben wieder vermehrt in
  Innenräumen abspielt? In erster Linie hilft das Verständnis, wie genau
  Sars-CoV-2 übertragen wird. Im Fokus stand lange, dass die neuen Coronaviren
  vor allem über eine Tröpfchen- und Kontaktinfektion weitergegeben werden: also
  durch direktes Anhusten oder Ansprechen. Das Virus überträgt sich
  möglicherweise aber auch zu einem guten Teil über Aerosole, sprich über die
  Luft. 236 Wissenschaftler forderten im Juli in einem <Link href='https://academic.oup.com/cid/advance-article/doi/10.1093/cid/ciaa939/5867798' mdxType="Link">offenen Brief</Link> daher von
  der Weltgesundheitsorganisation (WHO) und anderen Behörden, das Risiko der
  Übertragung von Sars-CoV-2 durch Aerosole ernster zu nehmen. Bis heute messen
  jedoch weder die WHO, das Bundesamt für Gesundheit (BAG) noch das
  amerikanische Center for Disease Control and Prevention (CDC)
  Aerosolübertragung viel Bedeutung zu – auch wenn sie mittlerweilen diesen
  Übertragungsweg anerkennen. Im Juli <Link href='https://www.srf.ch/news/international/kampf-gegen-corona-aerosole-lueften-lueften-lueften' mdxType="Link">sagte Stefan Kuster</Link> vom BAG: «Es sieht
  nach wie vor danach aus, dass Aerosole kein riesiger Treiber der Pandemie
  sind. Sonst hätten wir gerade in Clubs viel mehr Infizierte.»
    </p>
    <p>
  Unterschätzen die Behörden die Übertragung über die Luft? Viele
  Wissenschaftler sind davon überzeugt. Aus diesem Grund haben sich in den USA
  Aerosolforscher, Ingenieure und Virologen organisiert und eine <Link href='https://docs.google.com/document/d/1fB5pysccOHvxphpTmCG_TGdytavMmc1cUumn8m0pwzo/edit' mdxType="Link">lange Liste</Link> von
  Fragen und Antworten für die Öffentlichkeit zusammengestellt. Wir zeigen hier
  wichtige Erkenntnisse daraus auf, damit jede und jeder das Risiko einer
  Ansteckung minimieren kann.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;